module.exports = __webpack_public_path__ + "media/icon-star.3614fc6e.svg";